/* eslint-disable import/no-mutable-exports */
import * as Services from '../services';
import * as types from './actionTypes';

export const FetchOPDNotifications = () => dispatch =>
  dispatch({
    type: types.GET_OPD_NOTIFICATIONS,
    async payload() {
      return Services.fetchOPDNotifications();
    }
  });
